import * as React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { WizardHotelPWA } from "./WizardHotelPWA";
import { WizardHotelPWAExpando } from "./views/WizardHotelPWAExpando";
import { WizardHotelPWAViewsProps, WizardHotelPWAFTNodeOptions } from "./typings";
import { withStores } from "stores";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";

export const WizardHotelPWAViews = withStores(
  "analytics",
  "context",
  "cookies",
  "compositionStore",
  "wizardState",
  "flexModuleModelStore"
)((props: WizardHotelPWAViewsProps) => {
  const model = props.flexModuleModelStore.getModel(props.flexTemplateNode.id);
  const history = useHistory();
  const location = useLocation();

  if (!model) {
    return null;
  }

  const options = normalizeOptionsData(props.flexTemplateNode, model) as WizardHotelPWAFTNodeOptions;

  if (options.flexComponentView === "expando") {
    return <WizardHotelPWAExpando {...props} history={history} location={location} />;
  }

  return <WizardHotelPWA {...props} history={history} location={location} />;
});

export default WizardHotelPWAViews;
